var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('div',{staticClass:"pa-4 pb-0"}),_c('div',{staticClass:"card-padding"},[_c('div',{staticClass:"chart"},[_c('canvas',{staticClass:"chart-canvas",attrs:{"id":'doughnut-chart' + _vm.chartId,"height":"255"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }